export interface CardItemModel {
	img?: string;
	title: string;
	subTitle: string;
	data?: any;
}